import React, { useContext, useEffect, useState } from "react"
import "./InfoPages.css"
import {
  PictureBanner,
  BannerImageBig,
  BannerImageSmall,
} from "./InfoPages.styles"
import KlassementTable from "../Klassement/KlassementTable"
import EscapeRoomData from "../EscaperoomsPage/components/EscapeRoomData"
import {
  faPlayCircle,
  faShoppingCart,
  faHourglassHalf,
  faLightbulb,
  faLaptop,
  faStreetView,
  faWifi,
  faPencilAlt,
  faGamepad,
  faCheckCircle,
  faUsers,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Link } from "react-router-dom"
import IconBanner from "../shared/elements/IconBanner"
import Loaderspinner from "../shared/elements/Loaderspinner"
import { AppContext } from "../shared/context/AppContext"
import { Helmet } from "react-helmet"
import Screenshots from "./components/Screenshots"
import PageNotFound from "../PageNotFound/PageNotFound"
import { useParams } from "react-router"

function InfoPage() {
  const { language } = useContext(AppContext)
  const nl = language === "NL"
  const [isLoading, setIsLoading] = useState(true)
  const [klassementData, setKlassementData] = useState()

  const { linktoPar } = useParams()
  const room = EscapeRoomData.find((x) => x.linkto === linktoPar)
  const {
    difficulty,
    id,
    estTime,
    price,
    text,
    textEN,
    linkto,
    URL,
    players,
    title,
    titleEN,
    themeColor,
    gifName,
    numParts,
    bannerName,
    bannerNameSmall,
    dutch,
    english,
  } = room || {}

  useEffect(() => {
    if (!id) return
    const fetchData = async () => {
      setIsLoading(true)
      try {
        const response = await fetch(
          process.env.REACT_APP_BACKENDURL + "/website/rankings/getranking",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              rankingId: id,
            }),
          }
        )
        const data = await response.json()

        if (!response.ok) {
          throw new Error(data.errorMsg)
        }
        setKlassementData(data.rankingData)
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
        console.log(err.message)
      }
    }
    fetchData()
  }, [id])

  // An old or mistyped link
  if (!room) {
    return <PageNotFound />
  }

  const name = nl ? title : titleEN

  const howItWorks = [
    {
      icon: faGamepad,
      title: "Online game",
      titleEN: "Online game",
      text: `${title} speel je gewoon in je browser. Je logt in met je toegangscode en lost samen puzzels op om de escape room uit te spelen.`,
      textEN: `You play ${titleEN} right in your browser. You log in with your access code and solve puzzles together to finish the escape room.`,
    },
    {
      icon: faStreetView,
      title: "360°",
      titleEN: "360°",
      text: "Kijk 360° om je heen en loop rond om aanwijzingen te vinden en de puzzels op te lossen.",
      textEN:
        "Look around in 360° and walk around to find clues and solve the puzzles.",
    },
    {
      icon: faHourglassHalf,
      title: "In je eigen tempo",
      titleEN: "At your own pace",
      text: `De escape room bestaat uit ${numParts} delen, samen goed voor ongeveer ${estTime} minuten. Tussen de delen door kun je pauzeren en een andere keer verder spelen.`,
      textEN: `The escape room has ${numParts} parts, together about ${estTime} minutes. You can take a break between the parts and continue another time.`,
    },
    {
      icon: faLightbulb,
      title: "Hints",
      titleEN: "Hints",
      text: "Kom je ergens echt niet uit? Dan kun je een hint nemen, zodat je nooit vast komt te zitten. Er komt dan wel wat extra tijd bij je eindtijd.",
      textEN:
        "Really stuck? Then you can take a hint, so you never get stuck. It does add some extra time to your final time.",
    },
    {
      icon: faLaptop,
      title: "Samen spelen",
      titleEN: "Play together",
      text: "Log met meerdere mensen tegelijk in met dezelfde code, op laptops, tablets of telefoons. Tijd, hints en voortgang lopen voor iedereen gelijk.",
      textEN:
        "Log in with several people at once using the same code, on laptops, tablets or phones. Time, hints and progress stay in sync for everyone.",
    },
  ]

  const whatYouNeed = [
    {
      icon: faWifi,
      title: "Een laptop of tablet",
      titleEN: "A laptop or tablet",
      text: "Met internet. Spelen op je telefoon kan ook, maar op een klein scherm zijn de aanwijzingen lastiger te lezen en werkt niet alles even goed.",
      textEN:
        "With internet. You can also play on your phone, but on a small screen the clues are harder to read and not everything works as well.",
    },
    {
      icon: faPencilAlt,
      title: "Pen en papier",
      titleEN: "Pen and paper",
      text: "Handig om aantekeningen te maken tijdens het puzzelen. Een digitaal kladblok werkt natuurlijk ook.",
      textEN:
        "Handy for taking notes while puzzling. A digital notepad works too, of course.",
    },
  ]

  const buyButton = (
    <Link
      to={`/escaperooms/pay/${linkto}`}
      className={`blue-button ${id}-background-color buy-button`}
    >
      <FontAwesomeIcon icon={faShoppingCart} />
      {nl ? "Kopen" : "Buy"}
    </Link>
  )

  return (
    <main className="page info-page">
      <style>
        {`.${id}-background-color {background-color: ${themeColor};}
        .${id}-color {color: ${themeColor};}`}
      </style>
      <Helmet>
        <title>Escape room {name} | Escape Mystery</title>
      </Helmet>

      <PictureBanner>
        <BannerImageBig
          alt={name}
          src={require(`./banners/${bannerName}`).default}
        />
        <BannerImageSmall
          alt={name}
          src={require(`./banners/${bannerNameSmall}`).default}
        />
      </PictureBanner>

      <IconBanner
        difficulty={difficulty}
        estTime={estTime}
        price={price}
        players={players}
        id={id}
        dutch={dutch}
        english={english}
      />

      <section className="light-bg">
        <div className="page-content info-top">
          <div className="info-media">
            <Screenshots id={id} gifName={gifName} />
          </div>

          <aside className="buy-card">
            <h1>{name}</h1>
            <p className="buy-price">
              <span>€ {price},-</span> / team
            </p>
            {buyButton}
            <ul className="buy-footnotes">
              <li>
                <FontAwesomeIcon icon={faCheckCircle} />
                {nl
                  ? "Direct na betaling spelen"
                  : "Play right after paying"}
              </li>
              <li>
                <FontAwesomeIcon icon={faUsers} />
                {nl
                  ? `Voor een team van ${players} personen`
                  : `For a team of ${players} people`}
              </li>
              <li>
                <FontAwesomeIcon icon={faLaptop} />
                {nl
                  ? "Samen spelen op meerdere apparaten"
                  : "Play together on several devices"}
              </li>
            </ul>
            <p className="have-code">
              {nl ? "Heb je al een toegangscode? " : "Already have a code? "}
              <a href={URL} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faPlayCircle} />{" "}
                {nl ? "Start het spel" : "Start the game"}
              </a>
            </p>
          </aside>
        </div>
      </section>

      <section className="grey-bg">
        <div className="page-content info-story">
          <div>
            <h2>{nl ? "Het verhaal" : "The story"}</h2>
            <p className="story-text">{nl ? text : textEN}</p>
          </div>
          {Boolean(isLoading || klassementData?.length) && (
            <div>
              <h2>{nl ? "Snelste teams" : "Fastest teams"}</h2>
              {klassementData ? (
                <KlassementTable data={klassementData} limit={10} />
              ) : (
                <div id="rankings-loader-wrapper">
                  <Loaderspinner />
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <section className="light-bg">
        <div className="page-content">
          <h2 className="centeralign">
            {nl ? "Hoe werkt het?" : "How does it work?"}
          </h2>
          <InfoGrid items={howItWorks} id={id} nl={nl} />
        </div>
      </section>

      <section className="grey-bg">
        <div className="page-content">
          <h2 className="centeralign">
            {nl ? "Wat heb je nodig?" : "What do you need?"}
          </h2>
          <InfoGrid items={whatYouNeed} id={id} nl={nl} />
        </div>
      </section>

      {/* One more chance to buy, for those who read to the bottom */}
      <section className="light-bg">
        <div className="page-content info-cta">
          <h2>{nl ? "Klaar om te ontsnappen?" : "Ready to escape?"}</h2>
          <p>
            {nl
              ? `${name}, € ${price},- per team. Je krijgt de toegangscode direct per e-mail.`
              : `${name}, € ${price} per team. You get the access code by e-mail right away.`}
          </p>
          {buyButton}
        </div>
      </section>
    </main>
  )
}

function InfoGrid({ items, id, nl }) {
  return (
    <ul className="info-grid">
      {items.map((item) => (
        <li className="info-card" key={item.title}>
          <span className={`info-card-icon ${id}-color`} aria-hidden="true">
            <FontAwesomeIcon icon={item.icon} />
          </span>
          <h3>{nl ? item.title : item.titleEN}</h3>
          <p>{nl ? item.text : item.textEN}</p>
        </li>
      ))}
    </ul>
  )
}

export default InfoPage
